import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const WebmailPage = lazy(() => import('../communication').then(m => ({ default: m.WebmailPage })));
const EmailAccountsPage = lazy(() => import('../communication').then(m => ({ default: m.EmailAccountsPage })));
const EmailDomainsPage = lazy(() => import('./pages/EmailDomainsPage'));
const EmailRoutingPage = lazy(() => import('./pages/EmailRoutingPage'));
const EmailTemplatesPage = lazy(() => import('../communication').then(m => ({ default: m.EmailTemplatesPage })));
const EmailLoggingPage = lazy(() => import('../communication').then(m => ({ default: m.EmailLoggingPage })));

export const EmailRoutes: RouteObject = {
  path: 'email',
  element: <ModuleGuard moduleId="core.email" />,
  children: [
    { path: 'webmail', element: <WebmailPage />, handle: { crumb: 'Webmail' } },
    { path: 'accounts', element: <EmailAccountsPage />, handle: { crumb: 'Email Accounts' } },
    { path: 'domains', element: <EmailDomainsPage />, handle: { crumb: 'Domains & DNS' } },
    { path: 'routing', element: <EmailRoutingPage />, handle: { crumb: 'Routing & Policies' } },
    { path: 'templates', element: <EmailTemplatesPage />, handle: { crumb: 'Email Templates' } },
    { path: 'logs', element: <EmailLoggingPage />, handle: { crumb: 'Delivery Logs' } },
  ],
};
